import { render, staticRenderFns } from "./generalAlert.vue?vue&type=template&id=ffe74ae6&"
import script from "./generalAlert.vue?vue&type=script&lang=js&"
export * from "./generalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports